import { Component, Inject } from '@angular/core'
import { MatButton } from '@angular/material/button'
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog'
import { NgForOf, NgIf } from '@angular/common'
import { DialogComponentModel } from './dialog.component.model'
import { closeLabelToken } from '../providers/close-label.provider'

@Component({
  selector: 'sans-dialog-component',
  standalone: true,
  imports: [
    MatDialogClose,
    NgIf,
    MatDialogTitle,
    MatDialogContent,
    NgForOf,
    MatDialogActions,
    MatButton,
  ],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.css',
})
export class DialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public model: DialogComponentModel,
    @Inject(closeLabelToken) public closeLabel: string,
  ) {}
}
